import { InsightsEpisode } from '@api/api/insights';
import { RangeHorizon } from '@chart';
import { RevampTableColumn, RevampTableRow } from '@design/components/table';
import { Formats, formatDateToLocale } from '@helpers/utils/dates/dates';
import { useLanguageStore } from '@terminal/stores/use-language-store/useLanguageStore';
import type { TFunction } from 'i18next';

export const getColumns = (
  totalTradingDays: number,
  t: TFunction
): RevampTableColumn[] => [
  {
    id: 'episodeNo',
    title: t('widget:pastEpisode.table.episodeNo'),
    type: 'number',
    alignment: 'left',
  },
  {
    id: 'date',
    title: t('widget:pastEpisode.table.episodeDate'),
    type: 'text',
  },
  {
    id: 'tradingDays',
    title: t('widget:pastEpisode.table.tradingDays', {
      totalTradingDays: totalTradingDays,
    }),
    type: 'number',
    alignment: 'right',
  },
];

export const mapEpisodesToTableRow = (
  episodes: InsightsEpisode[]
): RevampTableRow[] => {
  const languageSetting = useLanguageStore.getState().languageSetting;
  return episodes.map((episode, index) => ({
    episodeNo: { value: index + 1 },
    date: {
      value: formatDateToLocale(
        languageSetting,
        new Date(episode.start_date),
        Formats['yyyy-MM-dd']
      ),
    },
    tradingDays: { value: episode.events.length },
  }));
};

export const getHorizonsLabels = (t: TFunction, horizons: RangeHorizon[]) => {
  return horizons.map(horizon =>
    /* i18next-extract-mark-context-next-line ["OneMonth", "ThreeMonths", "SixMonths", "OneYear", "ThreeYears", "Max"] */
    t('widget:insights.insightHorizon', { context: horizon })
  );
};
